import { attr } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

const Foreground = ApplicationRecord.extend({
  static: {
    jsonapiType: 'foregrounds',
  },
  attrs: {
    color: attr(),
    imageUrl: attr(),
    senior: attr(),
    studentId: attr(),
    season: attr(),
    // Name-zone params for the dynamic name preview (blank template = plain overlay).
    nameTemplate: attr(),
    nameColor: attr(),
    nameFont: attr(),
    nameSizeMin: attr(),
    nameSizeMax: attr(),
    nameCenterX: attr(),
    nameCenterY: attr(),
    nameBoundLeft: attr(),
    nameBoundRight: attr(),
    nameFontUrl: attr(),
  },
});

export default Foreground;
